import type { LocaleMorpheus } from "@solvari/translations";

/**
 * The locale a request host maps to. Framework-agnostic and free of Nuxt `#imports` so it
 * can be reused both inside the Nuxt injection context (`useHost.ts`) and in raw Nitro
 * server middleware, which runs outside it.
 */
function hostAndUrlToLocale(host: string, path: string): LocaleMorpheus {
  switch (true) {
    case host.endsWith(".be") && /^\/fr(\/|$)/.test(path):
      return "be-FR";
    case host.endsWith(".be"):
      return "be-NL";
    case host.endsWith(".fr"):
      return "fr-FR";
    case host.endsWith(".dk"):
      return "dk-DA";
    case host.endsWith(".se"):
      return "se-SV";
    case host.endsWith(".nl"):
      return "nl-NL";
    default:
      // oxlint-disable-next-line no-console -- server log, unlike the browser console
      console.warn(
        `[hostAndUrlToLocale] Unexpected host "${host}", defaulting to nl-NL`,
      );
      return "nl-NL";
  }
}

export { hostAndUrlToLocale };
